import Cropper from 'react-cropper';

const getImageType = (file?: File) => file?.type.split('/').pop()?.toUpperCase() ?? '';

const formatImageSize = (file?: File) => {
  if (!file?.size) {
    return '';
  }

  const sizeKB = Math.round(file.size / 1024);
  const sizeMB = Math.round(sizeKB / 1024);

  if (sizeMB < 1) {
    return `${sizeKB} KB`;
  }

  return `${sizeMB} MB`;
};

type TCropData = {
  width: number;
  height: number;
  minWidth: number;
  minHeight: number;
  cropperInstance: Cropper;
  isExactParams?: boolean;
};

const validateCropData = ({
  width,
  height,
  minWidth,
  minHeight,
  cropperInstance,
  isExactParams,
}: TCropData): {width: number; height: number} | void => {
  const cropBoxData = cropperInstance.getCropBoxData();
  const containerData = cropperInstance.getContainerData();

  if (
    (width < minWidth && cropBoxData.width === containerData.width) ||
    (height < minHeight && cropBoxData.height === containerData.height)
  ) {
    return;
  }

  const {naturalWidth, naturalHeight} = cropperInstance.getImageData();

  if (naturalWidth < minWidth || naturalHeight < minHeight) {
    return;
  }

  const maxWidth = isExactParams ? minWidth : Infinity;
  const maxHeight = isExactParams ? minHeight : Infinity;

  if (width < minWidth || height < minHeight || width > maxWidth || height > maxHeight) {
    const maxCropperWidth = maxWidth ? Math.min(maxWidth, width) : width;
    const maxCropperHeight = maxHeight ? Math.min(maxHeight, height) : height;

    return {
      width: Math.max(minWidth, Math.round(maxCropperWidth)),
      height: Math.max(minHeight, Math.round(maxCropperHeight)),
    };
  }
};

const createImgFromFile = (file: File, callback: (img: HTMLImageElement, src: string) => void) => {
  const fr = new FileReader();

  fr.onload = () => {
    if (typeof fr.result === 'string') {
      const src = fr.result;
      const img = document.createElement('img');

      img.onload = () => callback(img, src);
      img.src = src;
    }
  };
  fr.readAsDataURL(file);
};

export {getImageType, formatImageSize, validateCropData, createImgFromFile};
